import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Alert, notification, Modal, Table, Space, Card, InputNumber} from 'antd';
import { CaretLeftOutlined, CaretRightOutlined, PlusOutlined, SearchOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { inject, observer } from 'mobx-react'
import { Html5QrcodeScanner } from "html5-qrcode";
import moment from "moment-timezone";
import QRScanner from "../QRScanner";

import "./style.scss";

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;

const EventRegistration = ({ userStore, voterStore, eventStore }) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    let { id } = useParams();

    const [selectedVoter, setSelectedVoter] = useState()
    const [searchName, setSearchName] = useState();
    const [items, setItems] = useState([]);
    const [pricePerUnit, setPricePerUnit] = useState(0);
    const [total, setTotal] = useState(0);
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [eventDate, setEventDate] = useState();

    const [scanValues, setScanValues] = useState();

    useEffect(() => {
        const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];
        userStore.fetchUserLoadsTeamLeaderStatus(login_user.userID);
        userStore.fetchUserByID(login_user.userID);
    }, [])

    useEffect(() => {
        if (eventStore.event) {
            setStartTime(eventStore.event.RegistrationStart);
            setEndTime(eventStore.event.RegistrationEnd);
            setEventDate(eventStore.event.Date);
        }
    }, [eventStore.event]); // Runs when eventStore.event changes

    useEffect(() => {
        if (userStore.userLoadsItems && userStore.userLoadsItems.length > 0) {
            setItems(userStore.userLoadsItems);
        }
    }, [userStore.userLoadsItems]); // Runs whenever userLoadsItems changes
    
    useEffect(() => {
        if(selectedVoter) {
            form.setFieldsValue(selectedVoter)
        }
    }, [selectedVoter])

    useEffect(() => {
        voterStore.page = 1;
        voterStore.hasMore = false;
        voterStore.perPage = 5;
        voterStore.fetchVoters();
        if(id){
            eventStore.fetchEventByID(id);
        }
    }, [])

    const handlePrevPage = () => {
        voterStore.page = voterStore.page - 1;
        if(searchName){
            voterStore.searchVoters(searchName);
        }else{
            voterStore.fetchVoters();
        }
        
    };

    const handleNextPage = () => {
        voterStore.page = voterStore.page + 1;
        if(searchName){
            voterStore.searchVoters(searchName);
        }else{
            voterStore.fetchVoters();
        }
    };

    const handleSearchVoter = () => {
        if (!searchName){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a Voter Name'
            });
            return;
        } else if(searchName == ""){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a Voter Name'
            });
            return;
        } else{
            voterStore.searchVoters(searchName);
        }
    };

    const columns = [
        {
          title: 'Name',
          key: 'FullName+VIN',
          dataIndex: 'FullName',
          render: (FullName) => (
            <Text default>{FullName}</Text>
          )
        },
        {
          title: 'Precinct',
          key: 'Precint+VIN',
          dataIndex: 'Precint',
          render: (Precint) => (
            <Text default>{Precint}</Text>
          )
        },
        {
          title: 'Street',
          key: 'Street+VIN',
          dataIndex: 'Street',
          render: (Street) => (
            <Text default>{Street}</Text>
          )
        },
        {
          title: 'Address',
          key: 'Address+VIN',
          dataIndex: 'Address',
          render: (Address) => (
            <Text default>{Address}</Text>
          )
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          fixed: "right",
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost
                    onClick={() => setSelectedVoter(record)}
                >Select</Button>
            </Space>
          )
        },
    ];

    const columnItems = [
        {
          title: 'Item Name',
          key: 'ItemName+UserLoadID',
          dataIndex: 'ItemName',
          render: (ItemName) => (
            <Text strong>{ItemName}</Text>
          )
        },
        {
          title: 'PPU',
          key: 'PricePerUnit+UserLoadID',
          dataIndex: 'PricePerUnit',
          render: (PricePerUnit) => (
            <Text strong>₱{formatNumber(PricePerUnit)}</Text>
          )
        },
        {
          title: 'Quantity',
          key: 'Quantity+UserLoadID',
          dataIndex: 'Quantity',
          render: (Quantity) => (
            <Text strong>{Quantity}</Text>
          )
        },
        {
          title: 'Released Quantity',
          key: 'ReleasedQuantity+UserLoadID',
          dataIndex: 'ReleasedQuantity',
          render: (ReleasedQuantity) => (
            <Text default>{ReleasedQuantity}</Text>
          )
        },
        {
            title: 'Total Amount',
            key: 'Amount+UserLoadID',
            dataIndex: 'Amount',
            render: (Amount) => (
                <Text strong>₱{formatNumber(Amount)}</Text>
            )
        },
    ];

    const formatNumber = (formatnumber) => {
        return new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(formatnumber);
    };

    // FOR MODAL ADDING OF NEW ITEM TO USER -------------------------------
    const handleItemChange = (value) => {

        const selectedItem = items.find(item => item.UserLoadID === value);
        if (!selectedItem) return;

        setPricePerUnit(parseFloat(selectedItem.PricePerUnit));

        // Keep the existing quantity value if it's already set
        const currentQuantity = form.getFieldValue('quantity') || 1; 

        form.setFieldsValue({
            item: selectedItem.UserLoadID,
            itemName: selectedItem.ItemName,
            quantity: currentQuantity,  // Preserve user's input
            itemAmount: parseFloat(selectedItem.PricePerUnit) * currentQuantity,
        });
    };
    
    const calculateAmount = (value) => {
        const selectedItem = items.find(item => item.UserLoadID === form.getFieldValue('item'));
        if (!selectedItem) return;
    
        form.setFieldsValue({ 
            itemAmount: parseFloat(selectedItem.PricePerUnit) * value 
        });
    };

    // FOR MODAL ADDING OF NEW ITEM TO USER -------------------------------


    // FOR MODAL OF SCANNER --------------------------------

    const handleScan = (values) => {

        setScanValues(values);

        console.log(values);

        form.setFieldsValue({
            FullName: values.FullName,
            Address: values.Address,
            Precint: values.Precinct,
            Sex: values.Sex
        });
    };

    // FOR MODAL OF SCANNER --------------------------------

    const handleSubmitEventRegistration = (values) => {
        const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];

        const cashAmount = values.cashAmount ? parseInt(values.cashAmount) : 0;
        const itemAmount = values.itemAmount ? parseInt(values.itemAmount) : 0;

        // FOR ITEMS IN CASE DIDNT SELECT
        const itemName = values.itemName ? values.itemName : null;
        const itemQuantity = values.quantity ? values.quantity : 0;
        const userLoadID = values.item ? values.item : null;

        if(cashAmount === 0 && itemAmount === 0){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please input Cash Amount or Select an Item to proceed.'
            });
            return;
        }

        if ( cashAmount > userStore.teamLeader.amount) {
            notification.error({
                top: 120,
                message: 'Not Enough Balance!',
                description: 'Not Enough Cash Balance to Distribute. Please double check your cash balance before you continue.'
            });
            return;
        }

        if ( itemAmount > userStore.teamLeader.itemAmount) {
            notification.error({
                top: 120,
                message: 'Not Enough Items!',
                description: 'Not Enough Items to Distribute. Please double check your item quantity balance before you continue.'
            });
            return;
        }

        // // COMMENT THIS IF YOU WANT TO CONTINUE EVEN IF THE TIME IS NOT EQUAL TO REGISTRATION TIME
        // // -----------------------------------------------------------------

        // Get current local time in HH:mm format with GMT+8 offset
        const currentTime = moment().utcOffset(8).format("HH:mm");
        console.log("Current Time:", currentTime);

        // Convert start and end time from UTC to GMT+8 and format to HH:mm
        const eventStartTime = moment.utc(startTime).format("HH:mm");
        const eventEndTime = moment.utc(endTime).format("HH:mm");

        console.log("Event Start Time:", eventStartTime);
        console.log("Event End Time:", eventEndTime);

        // if (moment.utc().isAfter(moment.utc(eventStore.event.Date, "YYYY-MM-DD"))) {
        //     notification.error({
        //         top: 120,
        //         message: 'Registration Closed!',
        //         description: `Registration is only allowed on  ${moment.utc(eventStore.event.Date).format("YYYY-MM-DD")} from ${moment.utc(startTime).format("hh:mm A")} to ${moment.utc(endTime).format("hh:mm A")}`
        //     });
        //     return;
        // }

        // Validate if the current time is within the allowed range
        // if (currentTime < eventStartTime || currentTime > eventEndTime) {
        //     notification.error({
        //         top: 120,
        //         message: 'Registration Closed!',
        //         description: `Registration is only allowed from ${moment.utc(startTime).format("hh:mm A")} 
        //                     to ${moment.utc(endTime).format("hh:mm A")}. Please check the registration time.`
        //     });
        //     return;
        // }

        // // -----------------------------------------------------------------
        // // COMMENT THIS IF YOU WANT TO CONTINUE EVEN IF THE TIME IS NOT EQUAL TO REGISTRATION TIME

        const datapost = {
            // Basic Information
            fullName: values.FullName,
            address: values.Address,
            precint: values.Precint,
            gender: values.Sex,
            votersID: selectedVoter ? selectedVoter.VIN : scanValues.VIN,
            // Item Information
            itemName: itemName,
            itemQuantity: itemQuantity,
            itemPricePerUnit: pricePerUnit,
            itemAmount: parseInt(itemAmount),
            // Cash Information
            cashAmount: parseInt(cashAmount),
            // Event Information
            eventID: id,
            eventName: eventStore.event && eventStore.event.EventName,
            // Userload to update for accurate quantity
            userLoadID: userLoadID,

            // For initial data update
            totalAmount: parseInt(cashAmount) + parseInt(itemAmount),
            status: 'PENDING',
        };

        Swal.fire({
            title: "Register Voter",
            icon: "question",
            text: "Add voter for this event?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: `Cancel`
        }).then((result) => {
            if (result.isConfirmed) {
               eventStore.createUserEventRegistration(datapost, login_user.fullName);
            } 
        })
    }

    return (
        <div className="admin-add-team-leader">
            <Content>
                <div className="admin-add-team-leader-content">
                    <Title level={5}><SearchOutlined /> Search Voter from the Masterlist</Title>
                    <Row gutter={[10, 10]}>
                        <Col>
                            <Input
                                placeholder="Enter name"
                                allowClear
                                value={searchName}
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </Col>
                        <Col>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearchVoter}>Search Voter</Button>
                        </Col>
                        
                    </Row>
                    <Divider/>
                    <Table pagination={false} columns={columns} dataSource={voterStore.voters} bordered scroll={{x: "max-content"}}/>
                    <ul className="pagination">
                        <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                        <li className="pagination-item"><a>{voterStore.page}</a></li>
                        <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                    </ul>
                </div>
            </Content>
            <Content>
                <div className="admin-add-team-leader-content">
                    <Col>
                        <Row className="admin-ayuda-header-eventadmin" gutter={[10, 10]}>
                            <Col xs={24} lg={8}>
                                <Card>
                                    <Title level={5}>Total Cash Amount To Distribute</Title>
                                    <Text type="secondary">This shows the total cash amount available for distribution.</Text>
                                    <Row justify={"space-between"}>
                                    <Col><Title level={3}>₱ {formatNumber(parseInt(userStore.teamLeader && userStore.teamLeader.amount))}</Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Card>
                                    <Title level={5}>Total Items Amount To Distribute</Title>
                                    <Text type="secondary">This shows the total items amount available (Price per unit x Quantity Available) for distribution. </Text>
                                    <Row justify={"space-between"}>
                                    <Col><Title level={3}>₱ {formatNumber(parseInt(userStore.teamLeader && userStore.teamLeader.itemAmount))}</Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Title level={5}> List of Items to Distribute</Title>
                        <Table pagination={false} columns={columnItems} dataSource={userStore.userLoadsItems} bordered scroll={{x: "max-content"}}/>
                    </Col>
                </div>
            </Content>
            <Content>
                <Form 
                    name="addbillingInformationForm"
                    layout="vertical"
                    form={form} 
                    onFinish={handleSubmitEventRegistration}
                    onValuesChange={(changedValues, allValues) => {

                        if (changedValues.quantity !== undefined || changedValues.item !== undefined) {
                            const selectedItem = items.find(i => i.UserLoadID === allValues.item);
                            if (selectedItem) {
                                const newAmount = (allValues.quantity || 1) * selectedItem.PricePerUnit;
                                form.setFieldsValue({ itemAmount: newAmount });

                                // Wait for the form to update, then calculate the total
                                setTimeout(() => {
                                    const cashAmountData = parseFloat(form.getFieldValue("cashAmount")) || 0;
                                    const itemAmountData = parseFloat(form.getFieldValue("itemAmount")) || 0;
                                    setTotal(cashAmountData + itemAmountData);
                                }, 0);
                            }
                        } else {
                            // Normal case where cashAmount changes
                            const cashAmountData = parseFloat(allValues.cashAmount) || 0;
                            const itemAmountData = parseFloat(allValues.itemAmount) || 0;
                            setTotal(cashAmountData + itemAmountData);
                        }
                    }}
                
                >
                    <div className="admin-add-team-leader-content">
                        <Row justify={"space-between"} align={"middle"}>
                            <Col>
                                <Title level={4}>Register Voter for Event</Title>
                            </Col>
                            <Col>
                                <Space>
                                    <QRScanner onScan={handleScan} />
                                </Space>
                            </Col>
                        </Row>
                        <Divider />
                        {/* Display Registration Time */}
                        <Row gutter={10} style={{ marginBottom: 16 }}>
                            <Col>
                                <Text strong>Registration Start Time:</Text>
                                <Text style={{ marginLeft: 8 }}>{startTime ? moment.utc(startTime).format('hh:mm A') : 'N/A'}</Text>
                            </Col>
                            <Col>
                                <Text strong>Registration End Time:</Text>
                                <Text style={{ marginLeft: 8 }}>{endTime ? moment.utc(endTime).format('hh:mm A') : 'N/A'}</Text>
                            </Col>
                        </Row>
                        <Row justify={'center'} gutter={10}>
                            <div className="form-container">
                                <Title level={5}>Basic Information</Title>
                                <Row gutter={10}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="Full Name"
                                            name="FullName"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Full Name.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Full Name" readOnly />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col span={24}>
                                        <Form.Item
                                            label="Address"
                                            name="Address"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Address.',
                                                },
                                            ]}
                                        >
                                            <TextArea placeholder="Enter Address" readOnly />
                                        </Form.Item>
                                    </Col>

                                    <Col span={12}>
                                        <Form.Item
                                            label="Precint #"
                                            name="Precint"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Pricint Number.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Pricint Number" readOnly />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Gender"
                                            name="Sex"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Gender.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Gender" readOnly />
                                        </Form.Item>
                                    </Col>
                                    <Divider/>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Cash Amount"
                                            name="cashAmount"
                                            rules={[
                                                {
                                                    required: false,
                                                    message: 'Please input Cash Amount',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Cash Amount"/>
                                        </Form.Item>
                                    </Col>
                                    <Divider/>
                                    {/* Items Dropdown */}
                                    <Col span={24}>
                                        <Form.Item
                                            label="Items"
                                            name="item"
                                            rules={[{ required: false, message: 'Please select an item.' }]}
                                        >
                                            <Select 
                                                placeholder="Select Item"
                                                onChange={handleItemChange}
                                            >
                                                {items.map(item => (
                                                    <Select.Option key={item.UserLoadID} value={item.UserLoadID}>
                                                        {item.ItemName + " (₱" + formatNumber(item.PricePerUnit) + ") - " + item.Quantity +" available"}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Item Name"
                                            name="itemName"
                                            rules={[
                                                {
                                                    required: false,
                                                    message: 'Please input Item Name',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Item Name"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        {/* Quantity Input */}
                                        <Form.Item
                                            label="Item Quantity"
                                            name="quantity"
                                            rules={[
                                                { required: false, message: 'Please input quantity.' },
                                                () => ({
                                                    validator(_, value) {
                                                        const selectedItem = items.find(i => i.UserLoadID === form.getFieldValue('item'));
                                                        if (selectedItem && value > selectedItem.Quantity) {
                                                            return Promise.reject(new Error(`Maximum available quantity: ${selectedItem.Quantity}`));
                                                        }
                                                        return Promise.resolve();
                                                    },
                                                }),
                                            ]}
                                        >
                                            <InputNumber
                                                min={1}
                                                style={{ width: "100%" }}
                                                onChange={(value) => calculateAmount(value)} // Ensure amount updates
                                                placeholder="Input Item Quantity"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        {/* Amount Field - Auto-calculated but editable */}
                                        <Form.Item
                                            label="Item Amount"
                                            name="itemAmount"
                                            rules={[{ required: false, message: 'Please input Amount.' }]}
                                        >
                                            <InputNumber 
                                                placeholder="Enter Amount" 
                                                style={{ width: "100%" }}
                                            />
                                        </Form.Item>
                                    </Col>
                
                                    <Divider/>
                                </Row>
                                <Row justify={'end'}>
                                <Space>
                                    <Title level={4} strong>Total Amount: </Title><Title level={4} strong type="danger">₱ {formatNumber(total)}</Title>
                                </Space>
                            </Row>
                            </div>
                        </Row>
                        <Divider/>
                        <Row justify={'end'} gutter={12}>
                            <Col>
                                <Button type="primary" htmlType="submit" icon={<PlusOutlined/>} loading={voterStore.loading}>Submit</Button>
                            </Col>
                            <Col>
                                <Button onClick={() => navigate(-1)} loading={voterStore.loading}>Back</Button>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Content>
        </div>
    );
};

export default inject('userStore', 'voterStore', 'eventStore')(observer(EventRegistration));
